'use client';

import type { ReactNode } from 'react';
import dynamic from 'next/dynamic';
import type { LocaleMessagesProvider, MessageLocale } from './index';

// `next/dynamic` inside a CLIENT module is what makes each locale its own
// chunk that only loads when rendered. Resolving the provider on the server
// (even via `await import()`) registers all four as client references of the
// layout, and Turbopack then emits <script> tags for every locale on every
// page (~900 KB). Default ssr:true keeps the page fully server-rendered.
const providers: Record<MessageLocale, LocaleMessagesProvider> = {
  'en-AU': dynamic(() => import('./en-AU')),
  'zh-TW': dynamic(() => import('./zh-TW')),
  'ja-JP': dynamic(() => import('./ja-JP')),
  'fr-FR': dynamic(() => import('./fr-FR')),
};

export default function LocaleMessages({
  locale,
  children,
}: {
  locale: MessageLocale;
  children: ReactNode;
}) {
  const Provider = providers[locale] ?? providers['en-AU'];
  return <Provider>{children}</Provider>;
}
